import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import DashboardLayout from './components/layout/DashboardLayout';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Trasteros from './pages/Trasteros';
import Clientes from './pages/Clientes';
import Reservas from './pages/Reservas';
import Pagos from './pages/Pagos';
import Incidencias from './pages/Incidencias';
import Ajustes from './pages/Ajustes';
import Codigos from './pages/Codigos';

import './index.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="trasteros" element={<Trasteros />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="reservas" element={<Reservas />} />
            <Route path="codigos" element={<Codigos />} />
            <Route path="pagos" element={<Pagos />} />
            <Route path="incidencias" element={<Incidencias />} />
            <Route path="ajustes" element={<Ajustes />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;